import { Alert, Box, Button, Typography } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import PageContentContainer from "../../Container/PageContentContainer";
import NavigationExtensionMyAccount from "../../NavigationBar/NavigationExtensionMyAccount";
import BonusOverview from "../../MyAccount/Bonus/BonusOverview";
import BonusOverviewSkeleton from "../../MyAccount/Bonus/BonusOverviewSkeleton";
import styles from "../../MyAccount/Bonus/bonusOverviewStyles";
import { useCurrentUser } from "../../../provider/CurrentUserProvider";
import { apiGet } from "../../../services/Api/apiCall";
import { BonusOverview as BonusOverviewData, DisabledBonusOverview } from "../../../types/BonusOverview";
import CaseAssignmentPreference from "../../MyAccount/Bonus/CaseAssignmentPreference";

export default function BonusPage() {
  const currentUser = useCurrentUser();
  const { data, isPending, isError, refetch } = useQuery({
    queryKey: ["bonusOverview", currentUser.id],
    queryFn: () => apiGet<BonusOverviewData | DisabledBonusOverview>("/bonus/me"),
    enabled: currentUser.hasBonusAccount,
  });

  let content = <Alert severity="info">Für dieses Konto ist kein Bonuskonto aktiviert.</Alert>;
  if (currentUser.hasBonusAccount) {
    if (isError) {
      content = <Alert severity="error" action={<Button onClick={() => refetch()}>Erneut laden</Button>}>Fälle und Bonus konnten nicht geladen werden.</Alert>;
    } else if (isPending) {
      content = <BonusOverviewSkeleton />;
    } else if (data?.enabled) {
      content = <BonusOverview overview={data} />;
    }
  }

  return (
    <>
      <NavigationExtensionMyAccount />
      <PageContentContainer>
        <Box sx={styles.content}>
          <Box sx={styles.heading}>
            <Typography variant="h1" component="h1">Mein Konto · Fälle und Bonus</Typography>
            <Typography sx={{ marginTop: "0.5rem" }} color="text.secondary">{currentUser.person.fullname}</Typography>
          </Box>
          {content}
          {currentUser.isLawyer && <CaseAssignmentPreference />}
        </Box>
      </PageContentContainer>
    </>
  );
}
